// src/components/OrderConfirmation.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOrder } from '../context/OrderContext';
import { Header } from '../layout';

const OrderConfirmation = () => {
  const navigate = useNavigate();
  const { state, dispatch } = useOrder();
  const orderType = state.orderType || 'ordine';

  useEffect(() => {
    // Reset dell'ordine dopo 5 secondi e redirect alla dashboard
    const timer = setTimeout(() => {
      dispatch({ type: 'RESET_ORDER' });
      navigate('/dashboard');
    }, 5000);

    return () => clearTimeout(timer);
  }, [dispatch, navigate]);

  return (
    <div className="min-h-screen bg-gray-100">
      <Header title={orderType === 'offerta' ? 'Conferma Offerta' : 'Conferma Ordine'} showBack={false} />

      <div className="container mx-auto px-4 py-6">
        <div className="max-w-lg mx-auto bg-white rounded-lg shadow p-6 text-center">
          <div className="text-green-500 text-5xl mb-4">✓</div>
          <h2 className="text-2xl font-bold mb-4">CONGRATULAZIONI!</h2>
          <p className="mb-4">
            {orderType === 'offerta'
              ? "LA TUA RICHIESTA D'OFFERTA E' STATA INOLTRATA ALL'UFFICIO DI COMPETENZA."
              : "LA TUA RICHIESTA D'ORDINE E' STATA INOLTRATA ALL'UFFICIO DI COMPETENZA."
            }
          </p>
          <p className="mb-8">
            POTRAI SEGUIRE LO STATO DELLA TUA RICHIESTA DIRETTAMENTE SULLA TUA APP
          </p>
          <p className="text-gray-500">
            Verrai reindirizzato automaticamente alla dashboard...
          </p>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmation;
